import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { useParams, Link } from "react-router-dom";
import { getBackendUrl } from "../utils/paths";

export default function BlogDetail() {
  const { id } = useParams();
  function resolveImage(path) {
    if (!path) return null;
    if (/^https?:\/\//i.test(path)) return path;
    if (path.startsWith('/backend/uploads/')) return getBackendUrl(path);
    if (path.startsWith('/uploads/')) return getBackendUrl(`/backend${path}`);
    return getBackendUrl(path);
  }
  const [post, setPost] = useState(null);

  useEffect(() => {
    const isNumeric = /^\d+$/.test(String(id));
    const base = getBackendUrl('/backend/api/public/blogs.php');
    const url = isNumeric ? `${base}?id=${id}` : `${base}?slug=${encodeURIComponent(id)}`;
    fetch(url)
      .then((r) => r.json())
      .then((d) => setPost(d.item || null))
      .catch(() => {});
  }, [id]);

  return (
    <>
      <Header />
      <section className="page-header">
        <div
          className="page-header__bg"
          style={{ backgroundImage: "url(assets/images/backgrounds/page-header-bg.jpg)" }}
        ></div>
        <div className="shape1 float-bob-x">
          <img src="assets/images/shapes/page-header-shape1.png" alt="" />
        </div>
        <div className="shape2">
          <img src="assets/images/shapes/page-header-shape2.png" alt="" />
        </div>
        <div className="container">
          <div className="page-header__inner" style={{display:'flex', alignItems:'center', gap: '12px'}}>
            <img src="assets/fonts/vikash.png" alt="Vikash" style={{height: 40}} />
            <h2 className="wow fadeInDown" data-wow-duration="1500ms" style={{margin:0}}>{post?.title || 'Blog'}</h2>
          </div>
        </div>
      </section>
      <div className="container my-5">
        {!post ? (
          <p>Loading...</p>
        ) : (
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <h2>{post.title}</h2>
              {post.image_path && (
                <img src={resolveImage(post.image_path)} alt="" style={{maxWidth:'100%', borderRadius:8, margin:'14px 0'}} />
              )}
              <div dangerouslySetInnerHTML={{ __html: post.content.replace(/\n/g, '<br/>') }} />
              <div className="mt-4">
                <Link to="/blog" className="thm-btn">Back to Blogs</Link>
              </div>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
}


